import React, { useState, useEffect } from 'react';
import clienteAxios from '../config/axiox';
import Select from 'react-select';
 
function Menu({setShowLoading, LoginOn}){
    const [menu , setMenu]=useState([])
    const [secciones , setSecciones]=useState([])
    const [seccion , setSeccion]=useState("")
    const [showModal, setShowModal] = React.useState(false);    
    const [IdSeccion, setIdSeccion]=useState("");      
    const [opcion, setOpcion]=useState("");
    const [descripcion, setDescripcion]=useState("");
    const [precio, setPrecio]=useState(0);
    const [idMenu, setIdMenu]=useState(0);
    const [estatus, setEstatus]=useState({});
    const [OpcionesSelect, setOpcionesSelect]=useState();
    const [msgError, setmsgError]=useState("");
    const [msgOK, setMsgOK]=useState("");
    const [modalEliminar,setModalEliminar]=useState(false)
    const [datosElimintar, setDatosElminar]=useState({})

    const OpEstatus=[
        {"value":1,"label":"Activo"},
        {"value":0,"label":"Inactivo"}
    ]
    useEffect(()=>{    
        ConsultarMenu()     
    },[]) 

    useEffect(()=>{    
            
    },[datosElimintar]) 


    const ConsultarMenu= async()=>{                       
            const data ={   
                "sp":"menu",         
                "op":"consultar",         
                "usuario":"",                
                "clave":""
              }
              const config = {
                headers: {
                    "Content-Type": "application/json",      
                }        
              }  
              let opciones=[]       
              let opcionesSelect=[] 
              let secciones=[]       
              setShowLoading(true)
              await clienteAxios.post(`api/sp`, data, config)
              .then(res=>{
                let secc=res.data.data[0]                                                  
                secc.forEach(element => {                   
                   const {idSeccion, seccion,imagen}=element                   
                   let menu={idSeccion, seccion, imagen}    
                   let dato={value:idSeccion, label: seccion}     
                   opcionesSelect=[...opcionesSelect, dato]                                                 
                   secciones=[...secciones, menu]                                                                        
                });   
                
                let op=res.data.data[1]                                                  
                op.forEach(element => {                   
                   const {IdMenu, idSeccion, seccion, opcion, descripcion, precio, estatus}=element
                   let menu={IdMenu, idSeccion, seccion, opcion, descripcion, precio, estatus}                                                  
                   opciones=[...opciones, menu]                                                                        
                });                                
                setMenu(opciones)         
                setSecciones(secciones)       
                setShowLoading(false)         
                setOpcionesSelect(opcionesSelect)
            }).catch(err=>{             
                setShowLoading(false)      
                console.log(err)
            });                     
        
    }
    const EliminarMenu=(opcion, seccion)=>{             
        let op={
            "idMenu":opcion.IdMenu,
            "seccion":opcion.seccion, 
            "opcion":opcion.opcion, 
            "descripcion":opcion.descripcion, 
            "precio":opcion.precio, 
            "estatus":opcion.precio
        }       
        setDatosElminar(op)
        setModalEliminar(true)        
    }

    const GuardarMenu=async(hacer, id=null)=>{
        let data={}
        if(hacer=='Eliminar'){                                    
            data ={   
                "sp":"menu",     
                "op":"eliminar",       
                "idMenu":id
                }            
        }

        if(hacer=='Guardar'){
            let op=idMenu ? 'editar':'agregar'
            data ={   
            "sp":"menu",         
            "op":op,         
            "idMenu": idMenu,
            "idSeccion": IdSeccion, 
            "opcion":opcion, 
            "descripcion": descripcion, 
            "precio": precio, 
            "estatus": 1              
            }

        }
        const config = {
          headers: {
              "Content-Type": "application/json",      
          }
        }          
        setShowLoading(true)
        await clienteAxios.post(`api/sp`, data, config)
        .then(res=>{                
                setShowLoading(false)    
                setShowModal(false)
                setModalEliminar(false)
                setDatosElminar({})                
                ConsultarMenu()
                setMsgOK('Se guardarón los cambios exitosamente!')
                
          }).catch(err=>{             
              setShowLoading(false)      
              console.log(err)
          });                      

    }

    const EditarMenu=(opcion, seccion)=>{   
        setMsgOK('')                
        if(!opcion ){
            setIdMenu(null)
            setIdMenu('')
            setOpcion('')
            setIdSeccion('')
            setDescripcion('')
            setPrecio('')
            setEstatus(null)
            setSeccion(null)                  
        }
        else{        
        setIdMenu(opcion.IdMenu)
        setOpcion(opcion.opcion)
        setIdSeccion(opcion.idSeccion)
        setDescripcion(opcion.descripcion)
        setPrecio(opcion.precio)
        setEstatus({"value":opcion.estatus, "label":opcion.estatus==1 ? "Activo":"Inactivo"})
        setSeccion(seccion.seccion)                           
        }
        setShowModal(true)   
    }
    const EditarSeccion=(id)=>{        
        setIdSeccion(id.value)
    }
    
    const Cancelareliminacion=()=>{
        setModalEliminar(false)
        setDatosElminar({})
    }
    return(
        <>
            {LoginOn && 
                <button className=' bg-green-700 text-white my-1 p-5 md:p-1 absolute w-40 right-1' onClick={()=>EditarMenu(null, null)}>
                    <span className='px-4'>Nuevo</span>
                    <box-icon name='comment-add' color="white" size="sm"></box-icon>
                </button>
            }
            {secciones.map((dato, index)=>(     
                <> 
                    <div key={index} className='bg-fondo m-1 shadow-md px-3 py-1 sm:full lg:w-1/2 mx-auto'>                                                                
                        <div className='p-2 md:m-3 w-full relative' >                       
                            <span className='font-bold uppercase w-full text-xl p-4 m-3 my-2 text-azul grid grid-cols-6'>                                        
                            {dato.seccion}
                            </span>              
                        {
                        menu.filter(x=> x.idSeccion===dato.idSeccion).map((op, index2)=>(
                            <div  key={index2} className='text-azul p-2 ms-5 pe-5 sm:w-1/2 md:w-full lg:full  grid grid-cols-1'>
                                <div className='w-full '>
                                    <div className='grid grid-cols-6 w-full'>
                                        <div className=' col-span-5 w-full '>
                                            <h2 className='border-none w-full text-lg font-medium'><spa>{op.opcion}</spa></h2>
                                            </div>
                                        <div className='text-left grid grid-cols-2 '>
                                            ${op.precio}.00
                                            {LoginOn &&        
                                            <>   
                                            <div className='grid grid-cols-2'>
                                                <span className='cursor-pointer block px-4 md:px-2' onClick={()=>EditarMenu(op, dato)} title='Editar'>
                                                    <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-edit" width="30" height="30" viewBox="0 0 24 24" stroke-width="1.5" stroke="#C6A75B" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                                        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                                        <path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1" />
                                                        <path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z" />
                                                        <path d="M16 5l3 3" />
                                                    </svg>
                                                </span>       
                                                    <span className='cursor-pointer block px-5 md:px-2 mx-3'  onClick={()=>EliminarMenu(op, dato)} title='Eliminar'>
                                                        <box-icon name='message-alt-x' color="red" siae="sm" ></box-icon>
                                                    </span>                              
                                                    </div>
                                                </>
                                            }
                                        </div>
                                    </div>
                                    <div className='ms-5 p-1 mx-5 md:w-1/2 lg:1/1 capitalize'>{op.descripcion}</div>
                                </div>
                                
                            </div>
                        ))
                        }
                        </div>                                                                                                 
                    </div>
                </>
            ))}



        {/* /Modal Editar */}
            {showModal && 
            <>
                <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                <div className="relative w-auto my-6 mx-auto ">
                    {/*content*/}
                    <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                    {/*header*/}
                    <div className="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
                        <h3 className="text-3xl font-semibold text-azul">
                        Menú
                        </h3>
                        <button className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none" onClick={() => setShowModal(false)}>
                        <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                        <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-square-x" width="44" height="44" viewBox="0 0 24 24" stroke-width="1.5" stroke="#C6A75B" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                <path d="M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14z" />
                                <path d="M9 9l6 6m0 -6l-6 6" />
                        </svg>
                        </span>
                        </button>
                    </div>                
                    <div className="relative p-6 flex-auto">                                        
                        <div className="w-full">
                            {/* <input type='text' className="form_control"  value={idMenu} /> */}
                            <label className="label_form">Sección</label>
                            <Select 
                            defaultValue={{ label: seccion, value: IdSeccion }}                         
                            options={OpcionesSelect} 
                            className="basic-multi-select" 
                            classNamePrefix="select"                         
                            onChange={(item)=>EditarSeccion(item)} required/>          
                        </div>      
                        <div className="w-full mt-3">
                            <label className="label_form">Título</label>
                            <input type="text" className="form_control" required value={opcion} onChange={({target: {value}})=>setOpcion(value)} />
                        </div>                                         
                        <div className="w-full mt-3">
                            <label className="label_form">Descripción</label>
                            <textarea className="form_control" rows={3}  onChange={({target: {value}})=>setDescripcion(value)} >{descripcion}</textarea>
                        </div> 
                        <div className="w-full mt-3">
                            <label className="label_form">Precio</label>
                            <input type="text" className="form_control" placeholder="correo@dominio.com" required value={precio}  onChange={({target: {value}})=>setPrecio(value)} />
                        </div>  
                       
                    </div>       
                    {msgOK &&                         
                        <div className='w-full bg-green-600 text-white block p-4'>
                            <span >{msgOK}</span>
                        </div>
                    }
                    <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">                                        
                        <button className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button" onClick={() => setShowModal(false)} > Cancelar</button>
                        <button className="bg-azul text-white active:bg-dorado font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button" onClick={() => GuardarMenu('Guardar', null)}>Guardar</button>
                    </div>
                    </div>
                </div>
                </div>
                <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
            </>
            }

            {/* modal eliminar */}
            {modalEliminar && 
            <>
                <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                    <div className="relative w-auto my-6 mx-auto ">
                    {/*content*/}
                    <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                        {/*header*/}
                        <div className="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
                        <h3 className="text-3xl font-semibold text-red-600">
                            Eilminar del Menú
                        </h3>
                        <button className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none" onClick={() => setShowModal(false)}>
                            <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                            <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-square-x" width="44" height="44" viewBox="0 0 24 24" stroke-width="1.5" stroke="#C6A75B" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                    <path d="M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14z" />
                                    <path d="M9 9l6 6m0 -6l-6 6" />
                            </svg>
                            </span>
                        </button>
                        </div>
                        {/*body*/}
                        <div className="relative p-6 flex-auto">
                            <div className="w-full">
                                <label className="label_form">Opcion:</label>
                                <sp className=" font-bold">{datosElimintar.opcion}</sp>
                                <p className=' text-center p-3'>{datosElimintar.descripcion}</p>
                                <p className=' text-right text-azul font-bold'>${datosElimintar.precio}.00</p>
                            </div>

                          

                        </div>
                            
                        {/*footer*/}
                        <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
                        <button className="text-azul background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button" onClick={() => Cancelareliminacion()} > Cancelar</button>
                        <button className="bg-red-600 text-white active:bg-dorado font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button" onClick={() => GuardarMenu('Eliminar',datosElimintar.idMenu)}>Eliminar</button>
                        </div>
                    </div>
                    </div>
                </div>
                <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
            </>
            }
        </>
    )
}

export default Menu;